import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { getProductosMasVendidos } from "../../../service/AffariService";

const VentaDialog = ({ visible, onCancel, codigo }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);

    useEffect(() => {
        if (visible && codigo) {
            setLoading(true);
            setData([]);
            getProductosMasVendidos(codigo, 10)
                .then(setData)
                .catch((error) => {
                    console.error("Error fetching sales data:", error);
                })
                .finally(() => setLoading(false));
        }
    }, [visible, codigo]);

    const header = (
        <div className="flex justify-content-end">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    return (
        <Dialog
            header={`Productos más vendidos`}
            visible={visible}
            className="p-fluid custom-dialog"
            modal
            onHide={onCancel}
            dismissableMask={true}
        >
            <>
                {loading ? (
                    <div className="flex justify-content-center">
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                    </div>
                ) : (
                    <DataTable 
                        value={data} 
                        emptyMessage="No se encontraron productos." 
                        showGridlines 
                        stripedRows 
                        size="small"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        className="p-datatable-gridlines "
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} productos"
                        globalFilter={globalFilter}
                        header={header}
                        globalFilterFields={['codigo', 'glosa']}
                    >
                        <Column header="#" body={(data, options) => options.rowIndex + 1} style={{ width: '3rem' }} />
                        <Column field="codigo" header="Código" sortable />
                        <Column field="glosa" header="Glosa" sortable />
                        <Column field="total" header="Total" sortable />
                    </DataTable>
                )}
            </>
        </Dialog>
    );
};

export default VentaDialog;
